    document.addEventListener('DOMContentLoaded', function() {
        const offerItems = document.querySelectorAll('.product-info__offer-item');
        
        offerItems.forEach(item => {
            const duration = Math.random() * 3 + 2; // Random duration between 2 and 5 seconds
            const direction = Math.random() < 0.5 ? 'normal' : 'reverse'; // Random direction
            
            item.style.setProperty('--rotation-duration', `${duration}s`);
            item.style.setProperty('--rotation-direction', direction);
        });
    });